export default "9f203ac9ba3d12fd.svg"